import { Button } from "@classdojo/web/nessie";
import { connect } from "react-redux";

type FollowProps = {
  user: { type: string } | null;
  following: { channelName: string }[];
  boardSlug: string;
};

function Follow({ user, following, boardSlug }: FollowProps) {
  if (following === null) {
    following = [];
  }

  if (!user) {
    return null;
  }

  const isTeacher = user && user.type === "teacher";

  if (!isTeacher) {
    return null;
  }

  const isFollowing = following.find(({ channelName }) => channelName === boardSlug);

  return isFollowing ? (
    <Button
      data-name="follow:follow.following"
      size="s"
      disabled={Boolean(isFollowing)}
      sx={{ paddingY: "xs", span: { fontSize: "14px" } }}
    >
      Following
    </Button>
  ) : (
    <Button
      data-name="follow:follow.follow"
      size="s"
      disabled={Boolean(isFollowing)}
      sx={{ paddingY: "xs", span: { fontSize: "14px" } }}
    >
      Follow
    </Button>
  );
}

export default connect()(Follow);
